import React,{useState,createContext, useEffect} from 'react';
import axios from 'axios';

export const PortfolioPageContext = createContext();

const PortfolioPageContextProvider = (props) =>{
    const [portfoliopagedata,setPortfolioPageData]=useState();

    useEffect(()=>{
        getPortfolioPageData();
    },[])

    const getPortfolioPageData = async () =>{
        await axios({
            method:'get',
            url:`${process.env.REACT_APP_API_BASE_URL}/portfolio`,
            headers: {
              'Authorization': `${process.env.REACT_APP_HEADER_TOKEN}`
            }
          })
          .then((response)=>{
            setPortfolioPageData(response.data)
          })
          .catch((err)=>{
            console.log(err)
          })
    }

    return(
        <PortfolioPageContext.Provider value={{portfoliopagedata,setPortfolioPageData}}>
            {props.children}
        </PortfolioPageContext.Provider>
    )
}

export default PortfolioPageContextProvider;